import { useState, useEffect } from 'react';
import SearchBar from '../utilComponents/SearchBar';
import {
    Tabs,
    Tab,
    Container,
    Box
} from '@mui/material';

import Header from "../headers/Header";
import EloTable from '../dataDisplay/stats/main/EloTable'
import APNTable from '../dataDisplay/stats/main/APNTable';
import WinsTable from '../dataDisplay/stats/main/WinsTable';
import RaceCountTable from '../dataDisplay/stats/main/RaceCountTable';
import { fetchWithRetry } from '../utils/ApiHelper'
import LoadingShells from '../utilComponents/LoadingShells';
const Constants = require("../constants/Constants");
let IMAGE_URL = Constants.IMAGE_URL;


const StatsMain = () => {
    const [data, setData] = useState(null);
    const [selectedTab, setSelectedTab] = useState(0);
    const [loading, setLoading] = useState(true);


    useEffect(() => {
        const fetchData = async () => {
            try {
                console.log("Fetching data...");

                const statsResponse = await fetchWithRetry(
                    `${process.env.REACT_APP_STATS_BACKEND_ADDRESS || "/api/stats"}/home`,
                    {
                        headers: { accepts: "application/json" },
                        method: "GET",
                    }
                );
                const stats = await statsResponse.json();
                setData(stats);
                console.log("Data fetched successfully");
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const handleTabChange = (event, newValue) => {
        setSelectedTab(newValue);
    };

    // const getStatName = () => {
    //     switch (selectedTab) {
    //         case 0:
    //             return "currentElo";
    //         case 1:
    //             return "apn"
    //         case 2:
    //             return "winPercent";
    //         case 3:
    //             return "raceCount";
    //         default:
    //             return "currentElo";
    // }

    // }
    const renderTabContent = () => {

        switch (selectedTab) {
            case 0:
                // return data ? <MainStatsOverview overviewData={data.overviews} stat_name={getStatName()}/> : <p>No Data Available</p>;
                return data ? <EloTable rows={data.overviews} raceCountMin={10}/> : <p>No Data Available</p>;
            case 1:
                return data ? <APNTable rows={data.overviews} raceCountMin={10}/> : <p>No Data Available</p>;
            case 2:
                return data ? <WinsTable rows={data.overviews} raceCountMin={10}/> : <p>No Data Available</p>;
            case 3:
                return data ? <RaceCountTable rows={data.overviews} raceCountMin={10}/> : <p>No Data Available</p>;
            default:
                return null;
        
    }
    };

    return (
        <Container
            component="main"
            sx={{
                marginTop: 4,
                flexDirection: "column",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
            }}
        >
            <Box display="flex" justifyContent="center" alignItems="center" sx={{ p: 1 }}>
                <Header src={`${IMAGE_URL}headers/Stats.png`} alt="Stats Title" />
            </Box>
            {loading ? (
               <LoadingShells/>
        ) : <SearchBar grandPrixList={JSON.parse(localStorage.getItem("apiGrandPrixListV2"))} playerList={JSON.parse(localStorage.getItem("apiRosterV2"))}/>
    // ) : <SearchBar grandPrixList={["gp a", "gp b"]} playerList={["DK", "Mario", "Luigi"]}/>

            
        }
            {loading ? (
                <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "200px" }}>
                    {/* <CircularProgress /> */}
                </Box>
            ) : (
                <Box sx={{ width: "90wv", marginTop: 1 }}>
                    <Tabs
                        value={selectedTab}
                        onChange={handleTabChange}
                        centered
                        indicatorColor="primary"
                        textColor="primary"
                    >
                        <Tab label="Elo" />
                        <Tab label="APN" />
                        <Tab label="Wins" />
                        <Tab label="Races" />
                    </Tabs>
                    <Box sx={{ padding: 2, display: 'flex', alignItems: 'center', justifyContent: 'center', width: "50wv"}}>{renderTabContent()}</Box>
                </Box>
            )}
        </Container>
    );
};



export default StatsMain;
